// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const LazyImage = require('client-v2/common/components/lazy-image')
const useMatchMedia = require('client-v2/common/hooks/match-media')
const tag = require('client-v2/common/utils/hyperscript')
// Entry imports
const IntoFooter = require('client-v2/into-landing/components/footer')
const IntoLinkModal = require('client-v2/into-landing/containers/link-modal/component-smart')
const UserProfileFeed = require('./containers/feed/component-smart')

const bem = BemEntity('IntoUserProfileLayout')

function IntoUserProfileLayout(props) {
  const { items, user, onPaginate } = props
  const isWindowNarrow = useMatchMedia('(max-width: 850px)')
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('body')
      },
        tag('div', {
          className: bem.element('header')
        },
          tag(LazyImage,{
            className: bem.element('user-avatar'),
            sources: [ user['photo_url'] ]
          }),
          tag('div', {
            className: bem.element('username')
          },
            `@${user.username}`
          ),
          tag('div', {
            className: bem.element('display-name')
          },
            user['display_name']
          )
        ),
        tag(UserProfileFeed, {
          className: bem.element('grid'),
          items,
          onPaginate
        }),
        tag(IntoLinkModal, {
          caption: isWindowNarrow ? (
            tag('div', {
              className: bem.element('caption', 'small')
            },
              tag('span', {
                className: bem.element('links-username')
              },
                `${user['display_name']}`
              ),
              ' is using Mix to discover the best content from the open web.'
            )
          ) : null
        })
      ),
      tag(IntoFooter, {
        className: bem.element('footer')
      })
    )
  )
}

module.exports = IntoUserProfileLayout
